/*
**  rui-common-styles.js
**
**  Styling for common elements, for use in LitElement-based apps
*/
import { css } from 'lit-element';
export const ruiCommonStyles = css `

/* SCREEN READER-ONLY ELEMENTS */

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
}

`;
